export const EXCMTEAM_DELETE_RESET = 'EXCMTEAM_DELETE_RESET'
export const EXCMTEAM_DELETE_SET_ERROR = 'EXCMTEAM_DELETE_SET_ERROR'
export const EXCMTEAM_DELETE_SET_DELETED = 'EXCMTEAM_DELETE_SET_DELETED'
export const EXCMTEAM_DELETE_TOGGLE_LOADING = 'EXCMTEAM_DELETE_TOGGLE_LOADING'
